import { InjectionToken } from '@angular/core';

export const STORE_WRAPPER_TOKEN = new InjectionToken('STORE_WRAPPER_TOKEN');
